import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useResolvedT } from "@/i18n/monteur";

// CLARTEXT SPRACHE V1 – Phase 7E P0.2: Status-Labels laufen über den Monteur-
// i18n-Layer statt hartcodiertem Deutsch.
// P0-FIX (Juni 2026): Im Owner-/Unternehmer-Kontext MUSS `lang="de"` explizit
// gesetzt werden, sonst zieht eine parallel offene Mitarbeiter-Session deren
// Sprache (z. B. EN → „Open"). `useResolvedT(lang)` erzwingt bei gesetztem
// `lang` diese Sprache, sonst (Mitarbeiterflow, lang=null) = Session-Sprache.
const STATUS_CONFIG = {
  offen: {
    key: "status.offen",
    classes: "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100",
  },
  erledigt: {
    key: "status.erledigt",
    classes:
      "bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100",
  },
  ueberfaellig: {
    key: "status.ueberfaellig",
    classes: "bg-red-100 text-red-800 border-red-200 hover:bg-red-100",
  },
};

export default function StatusBadge({ status, className, testId, lang = null }) {
  const t = useResolvedT(lang);
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.offen;
  return (
    <Badge
      variant="outline"
      data-testid={testId || `status-badge-${status}`}
      className={cn(
        "rounded-md font-medium px-2.5 py-1 text-xs border",
        config.classes,
        className
      )}
    >
      {t(config.key)}
    </Badge>
  );
}
